module.exports = __webpack_public_path__ + "static/media/wR.0095917f.svg";